import { Skeleton } from '@/components/ui/skeleton'

export default function CourseCardSkeleton() {
  return (
    <div className="group w-full">
      <div className="relative w-full rounded-lg border border-gray-200 bg-[#f5f6fa] p-2 shadow-xs">
        <span className="absolute top-2 left-4 z-10 rounded bg-[#dbe4ff] p-1">
          <Skeleton className="h-4 w-16 bg-gray-300" />
        </span>

        <div className="relative overflow-hidden rounded-lg">
          <Skeleton className="h-42.25 w-full rounded-lg bg-gray-300" />

          <div className="absolute top-3 right-3">
            <Skeleton className="h-[20px] w-[64px] rounded-sm bg-gray-300" />
          </div>
        </div>

        <div className="mt-3">
          <div className="max-w-67.5 space-y-2">
            <Skeleton className="h-5 w-3/4 bg-gray-300" />
            <Skeleton className="h-4 w-full bg-gray-300" />
            <Skeleton className="h-4 w-5/6 bg-gray-300" />
          </div>

          <div className="mt-4">
            <div className="flex items-center justify-between border-gray-300 border-b pb-3">
              <div className="flex items-center gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Skeleton className="h-4 w-4 rounded bg-gray-300" key={i} />
                ))}
              </div>
              <Skeleton className="h-4 w-24 bg-gray-300" />
            </div>

            <div className="mt-4">
              <Skeleton className="h-10 w-32 rounded-md bg-gray-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
